import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import emailjsConfig from '../config/emailjs';
import './FormStyles.css';

const { publicKey: PUBLIC_KEY, serviceId: SERVICE_ID, templateId: TEMPLATE_ID } = emailjsConfig;

const Form = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('success');

  const showNotice = (message, type = 'success') => {
    setPopupMessage(message);
    setPopupType(type);
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 4000);
  };

  const validate = () => {
    const nextErrors = {};
    let valid = true;

    if (!formData.name.trim()) {
      nextErrors.name = 'Name is required';
      valid = false;
    }
    if (!formData.email.trim()) {
      nextErrors.email = 'Email is required';
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      nextErrors.email = 'Email address is invalid';
      valid = false;
    }
    if (!formData.subject.trim()) {
      nextErrors.subject = 'Subject is required';
      valid = false;
    }
    if (!formData.message.trim()) {
      nextErrors.message = 'Message is required';
      valid = false;
    }

    setErrors(nextErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
      showNotice(
        'Contact form is not configured yet. Please email aamir2saiyad@gmail.com directly.',
        'error'
      );
      return;
    }

    setIsSubmitting(true);

    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message,
          to_email: 'aamir2saiyad@gmail.com',
        },
        PUBLIC_KEY
      );

      setFormData({ name: '', email: '', subject: '', message: '' });
      setErrors({});
      showNotice('Message sent successfully! I will get back to you soon.');
    } catch (error) {
      console.error('EmailJS error:', error);
      showNotice('Failed to send message. Please try again or email me directly.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Your Name</label>
        <input
          id="name"
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          disabled={isSubmitting}
        />
        {errors.name && <p className="error">{errors.name}</p>}

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          disabled={isSubmitting}
        />
        {errors.email && <p className="error">{errors.email}</p>}

        <label htmlFor="subject">Subject</label>
        <input
          id="subject"
          type="text"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          disabled={isSubmitting}
        />
        {errors.subject && <p className="error">{errors.subject}</p>}

        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          rows="6"
          placeholder="Type your message here"
          name="message"
          value={formData.message}
          onChange={handleChange}
          disabled={isSubmitting}
        />
        {errors.message && <p className="error">{errors.message}</p>}

        <button className="btn" type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Sending...' : 'Submit'}
        </button>
      </form>

      {showPopup && (
        <div className={`popup ${popupType === 'error' ? 'popup-error' : ''}`}>
          {popupMessage}
        </div>
      )}
    </div>
  );
};

export default Form;
